import React, { useEffect } from 'react';
import { Form, Input, InputNumber, Button } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const SelectionPopup = ({
  selectedSign,
  showPopup,
  onClose,
  onConfirm,
  messageApi
}) => {
  const [form] = Form.useForm();

  // Reset form values when selectedSign changes to prevent stale data
  useEffect(() => {
    if (selectedSign && showPopup) {
      form.setFieldsValue({
        nome: selectedSign?.isManual ? selectedSign.id : `${selectedSign?.id || Date.now()}`,
        distanza: 100,
        durata_verde: 20,
        lunghezza_attraversamento: 10
      });
    }
  }, [selectedSign, showPopup, form]);

  if (!showPopup || !selectedSign) return null;

  const handleSubmit = (values) => {
    const newTraffic = {
      ...selectedSign,
      ...values,
      configured: true
    };
    onConfirm(newTraffic);
    form.resetFields();
  };

  const initialValues = {
    nome: selectedSign?.isManual ? selectedSign.id : `${selectedSign?.id || Date.now()}`,
    distanza: 100,
    durata_verde: 20,
    lunghezza_attraversamento: 10
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        zIndex: 1002,
        overflow: 'hidden'
      }}
    >
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%)',
        padding: '20px',
        borderBottom: '1px solid #e8e8e8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <h3 style={{
          margin: 0,
          fontSize: '18px',
          fontWeight: '600',
          color: '#1a1a1a'
        }}>
          Configura Semaforo
        </h3>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={() => {
            form.resetFields();
            onClose();
          }}
          style={{
            padding: 0,
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />
      </div>

      {/* Body */}
      <div style={{ padding: '24px' }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={initialValues}
        >
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px'
          }}>
            {/* Nome */}
            <Form.Item
              label="Nome*"
              name="nome"
              rules={[{ required: true, message: 'Inserisci nome' }]}
              style={{ marginBottom: 16 }}
            >
              <Input
                placeholder="Es. Semaforo 1"
                style={{
                  borderRadius: '8px',
                  borderColor: '#A1E430'
                }}
              />
            </Form.Item>

            {/* Distanza */}
            <Form.Item
              label="Distanza (m)"
              name="distanza"
              style={{ marginBottom: 16 }}
            >
              <InputNumber
                min={0}
                placeholder="100"
                style={{
                  width: '100%',
                  borderRadius: '8px'
                }}
              />
            </Form.Item>

            {/* Durata Verde */}
            <Form.Item
              label="Durata Verde (s)*"
              name="durata_verde"
              rules={[{ required: true, message: 'Inserisci durata' }]}
              style={{ marginBottom: 16 }}
            >
              <InputNumber
                min={1}
                placeholder="20"
                style={{
                  width: '100%',
                  borderRadius: '8px'
                }}
              />
            </Form.Item>

            {/* Lunghezza Attraversamento */}
            <Form.Item
              label="Lunghezza Attraversamento (m)*"
              name="lunghezza_attraversamento"
              rules={[{ required: true, message: 'Inserisci lunghezza' }]}
              style={{ marginBottom: 16 }}
            >
              <InputNumber
                min={1}
                placeholder="10"
                style={{
                  width: '100%',
                  borderRadius: '8px'
                }}
              />
            </Form.Item>
          </div>

          {/* Position Info */}
          <div style={{
            background: '#f5f5f5',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '20px',
            fontSize: '13px',
            color: '#666'
          }}>
            <div>ID: {selectedSign?.id}</div>
            <div>Lat: {selectedSign?.lat?.toFixed(6)}</div>
            <div>Lng: {selectedSign?.lng?.toFixed(6)}</div>
          </div>

          {/* Actions */}
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center'
          }}>
            <Button
              onClick={() => {
                form.resetFields();
                onClose();
              }}
              style={{
                borderRadius: '20px',
                height: '40px',
                width : "100%"
              }}
            >
              Annulla
            </Button>
            <Button
              htmlType="submit"
              icon={<CheckOutlined />}
              style={{
                color : "#fff",
                borderRadius: '20px',
                height: '40px',
                background: 'linear-gradient(135deg, #A1E430 0%, #8FD420 100%)',
                borderColor: '#A1E430',
                width : "100%"
              }}
            >
              Aggiungi
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SelectionPopup;